export class cuenta_bancaria {
    public empresa_rut: number;
    public tipo_cuenta_bancaria_codigo: number;
    public banco_codigo: number;
    public numero_cuenta: string;
    public observaciones: string;
    public activo: boolean;
}